<template>
  <div class="h-100">   
    <component v-bind:is="layout"/>
  </div>
</template>

<script>
import FrontendLayout from './layouts/FrontendLayout'

export default {
  computed: {
    layout () {
      return this.$store.getters['app/layout']
    }
  },
  components: {
    'frontend-layout': FrontendLayout
  },
   mounted() {
    // check for active theme
    let htmlElement = document.documentElement;
    let theme = localStorage.getItem("theme");

    if (theme === "dark") {
      htmlElement.setAttribute("theme", "dark");
      this.darkMode = true;
    } else {
      htmlElement.setAttribute("theme", "light");
      this.darkMode = false;
    }
  }
}
</script>
